import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M8.771 19.75a1.938 1.938 0 01-1.938-1.938V6.187a1.938 1.938 0 113.876 0v11.625c0 1.07-.867 1.938-1.938 1.938zM15.229 19.75a1.938 1.938 0 01-1.938-1.938V6.187a1.938 1.938 0 113.876 0v11.625c0 1.07-.867 1.938-1.938 1.938z"
}), 'Pause');